import {MapService} from '../MapService';
import {Graphic} from './Graphic';

/**
 * Creates a new PlacesGraphic for displaying Google Places places of interest
 * @return {PlacesGraphic} The constructed graphic.
 */
async function createPlacesGraphic() {
  return new PlacesGraphic();
}

const makeStyle = (featureType, elementType, color, options) => ({
  featureType,
  elementType,
  stylers: [
    {color},
    ...(options || []),
  ],
});

const makeOptions = (poiVisibility) => ({
  styles: [
    {
      featureType: 'poi',
      stylers: [{
        visibility: poiVisibility,
      }],
    },
    makeStyle('poi.business', 'labels.icon', '#90789b'),
    makeStyle('poi.business', 'labels.text.fill', '#ffffff'),
    makeStyle('poi.business', 'labels.text.stroke', '#191919'),
    makeStyle('poi.place_of_worship', 'labels.icon', '#ff24ed', [{saturation: -25}]),
    makeStyle('poi.place_of_worship', 'labels.text.fill', '#ffffff'),
    makeStyle('poi.place_of_worship', 'labels.text.stroke', '#191919'),
    makeStyle('poi.school', 'labels.icon', '#ff24ed', [{saturation: -25}]),
    makeStyle('poi.school', 'labels.text.fill', '#ffffff'),
    makeStyle('poi.school', 'labels.text.stroke', '#191919'),
  ],
  // Changing map options automatically turns clickable icons back on, ignoring the previous setting because google
  // is the south end of a northbound mule. So we need to set it back to what it should be.
  clickableIcons: false,
});

class PlacesGraphic extends Graphic {
  constructor() {
    super();
    /** @type {boolean} */
    this.clickable = true;
  }

  /**
   * Sets whether the markers for returned places of interest can be clicked
   * @param {boolean} clickable Whether or not the Google Places POI markers should be clickable
   */
  setClickable(clickable) {
    this.clickable = clickable;
    MapService.setOptions({clickableIcons: clickable});
  }

  isClickable() {
    return this.clickable;
  }

  /**
   * Shows or hides Google Places poi markers based off of the provided map passed in
   * @param {google.maps.Map|null} map The map to attach this graphic to,
   * or `null` to detach the graphic from its current map.
   */
  setMap(map) {
    if (map) {
      MapService.setOptions(makeOptions('on'));
    } else {
      MapService.setOptions(makeOptions('off'));
    }
  }
}

export {createPlacesGraphic, PlacesGraphic};
